// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TLIK","left":"styles_left__3lNnr","desktopActions":"styles_desktopActions__22nYC","title":"styles_title__3E95R"};